<script setup lang="ts">
import {formatting, Models, useRegistry} from '@hantera/portal-app'
import {Expandable} from "@hantera/design-system";
import useBackend from "@/composition/useBackend";
import AvailableInventoryTable from "@/components/Order/Deliveries/OrderLine/AvailableInventoryTable.vue";
import InventoryLabel from "@/components/Order/Deliveries/OrderLine/InventoryLabel.vue";

const props = defineProps<{
  orderLine: Models.Graph.OrderLine
}>()

const { graph } = useBackend()
const registry = useRegistry()

</script>

<template>
  
  <div class="container">
    
    <div
      v-for="sku in orderLine.skus"
      :key="sku.skuNumber"
      class="box-content"
    >
      <Expandable
        :label="sku.skuNumber"
        :model-value="true"
      >
        <div v-if="sku.stockReservations.length > 0">
          <div class="box-content-label">
            Reservations
          </div>
          
          <table class="p">
            <thead>
            <tr>
              <th>Inventory</th>
              <th>Reserved</th>
              <th>Date</th>
              <th>Allocation</th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="reservation in sku.stockReservations"
              :key="reservation.stockReservationId"
            >
              <td>
                <InventoryLabel :inventory-key="reservation.stockPosition.inventoryKey" />
              </td>
              <td>
                {{formatting.number(reservation.quantity)}}
              </td>
              <td>
                {{formatting.date(reservation.inventoryDate)}}
              </td>
              <td>
                {{reservation.allocation?.reference}}
              </td>
            </tr>
            </tbody>
          </table>
          
        </div>

        <div v-if="sku.backOrders.length > 0">
          <div class="box-content-label">
            Back orders
          </div>
          
          <table class="p">
            <thead>
            <tr>
              <th>Inventory</th>
              <th>Quantity</th>
              <th>Date</th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="backOrder in sku.backOrders"
              :key="backOrder.backOrderId"
            >
              <td>
                <InventoryLabel :inventory-key="backOrder.stockPosition.inventoryKey" />
              </td>
              <td>
                {{formatting.number(backOrder.quantity)}}
              </td>
              <td>
                {{formatting.date(backOrder.inventoryDate)}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        
        <AvailableInventoryTable :sku-number="sku.skuNumber" />
      </Expandable>
    </div>
    
  </div>
  
</template>

<style scoped>
:deep(.expandable__label) {
  padding: 5px;
}

.container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
</style>